var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9 2.7a.9.9 0 0 1 .9.9v4.5h4.5a.9.9 0 0 1 0 1.8H9.9v4.5a.9.9 0 1 1-1.8 0V9.9H3.6a.9.9 0 0 1 0-1.8h4.5V3.6a.9.9 0 0 1 .9-.9z",
    fill: "#4318ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBid);
export default __webpack_public_path__ + "static/media/add-bid.c3c433f6f8e17ecb2061aa39c3cff994.svg";
export { ForwardRef as ReactComponent };